import { useLocalizedNews } from '../../../../hooks'
import { NewsContentType } from '../../../../utils'
import { MessagesLayout } from '../../components'
import { NewsTabNavTitle, NewsTabContent } from './components'

export const News = () => {
  const newsItems = useLocalizedNews()
  const contentNewsItems = newsItems.filter(
    (newsItem) => newsItem.type === NewsContentType.CONTENT
  )

  return (
    <MessagesLayout
      headerTranslationId="pages.messagesPage.news.label"
      tabItems={contentNewsItems}
      TabContentElement={NewsTabContent}
      TabNavTitleElement={NewsTabNavTitle}
    />
  )
}
